// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"73a836eb","703":"faf3058e"}[chunkId] + ".chunk.js";
};